import { Menu as AntdMenu } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useApp } from '@/app/context';
import type { MenuItemConfig } from './lib/types';
import { findOpenedKeys, findSelectedKeys, getPathnameWithoutQuery } from './lib/utils';
import { createMenuItems } from './MenuItem';
import navigation from './menuItems';

interface MenuProps {
  onClose?: () => void;
}

const Menu = ({ onClose }: MenuProps) => {
  const { userPermissions } = useApp();

  const menuVisibleItems = (navigation as MenuItemConfig[]).filter((menuItem) =>
    userPermissions?.some((permission) =>
      !isEmpty(menuItem) ? menuItem.groupPermissions?.includes(permission) || menuItem.permission === permission : null,
    ),
  );

  const customise = useSelector((state: any) => state.customise);

  const { pathname } = useLocation();
  const currentLocation = getPathnameWithoutQuery(pathname);
  const defaultSelectedKey = findSelectedKeys(currentLocation, menuVisibleItems) || '';
  const defaultOpenKeys = findOpenedKeys(menuVisibleItems, defaultSelectedKey);

  const items = createMenuItems({
    menuVisibleItems,
    currentLocation,
    defaultSelectedKey,
    onClose,
    getPathnameWithoutQuery,
    userPermissions,
  });

  return (
    <AntdMenu
      mode="inline"
      theme={customise.theme}
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={[defaultSelectedKey]}
      selectedKeys={[defaultSelectedKey]}
      items={items}
    />
  );
};

export default Menu;
